import { Outlet, Navigate, useLocation } from 'react-router';
import { useAuthStore } from '@/state/auth.state';
import { Flex, Loader } from '@mantine/core';


export function AppGuard() {
    const authStore = useAuthStore();
    const location = useLocation();
    
    if (authStore.isLoading) {
        return (
            <div style={ {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100vh',
            } }>
                <Flex align='center' gap='middle'>
                    <Loader size='sm'/>
                </Flex>
            </div>
        );
    }
    
    if (!authStore.isAuthenticated) {
        return (
            <Navigate to={ `/sign-in?back=${ location.pathname + location.search }` }/>
        );
    }
    
    return (
        <Outlet/>
    );
}